import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  CardBody,
  Spinner
} from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Result = () => {

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {

    axios.get(
      // "http://localhost/qads_interview/result/my_result.php",
      "https://interview.qads.co.in/qads_interview/result/my_result.php",
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(res => {
        setResult(res.data.data);
      })
      .catch(err => {
        toast.error(err.response?.data?.message);
      })
      .finally(() => setLoading(false));

  }, [token]);

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner />
        <p>Fetching Result...</p>
      </Container>
    );
  }

  if (!result) return null;

  return (
    <Container className="mt-5">

      <Card className="shadow p-4">
        <CardBody>


          <h3 className="text-center mb-4">
            Interview Result
          </h3>

          <p><strong>Domain:</strong> {result.domain}</p>
          <p><strong>Status:</strong> {result.status}</p>
          <p><strong>Started At:</strong> {result.started_at}</p>
          <p><strong>Ended At:</strong> {result.ended_at}</p>

          {result.status === "Evaluated" && (
            <>
              <hr />
              <h5>Total Marks: {result.total_marks}</h5>
              <h5>Obtained Marks: {result.obtained_marks}</h5>
              <h5>Percentage: {result.percentage}%</h5>

              <hr />
              <h5>Question Breakdown:</h5>

              {result.question_breakdown.map((q, index) => (
                <Card key={index} className="mb-3 p-3">
                  <p><strong>Question:</strong> {q.question}</p>
                  <p><strong>Your Answer:</strong> {q.answer_text}</p>
                  <p><strong>Marks:</strong> {q.marks_awarded} / {q.max_marks}</p>
                </Card>
              ))}
            </>
          )}

          {result.status === "Under Review" && (
            <p className="text-warning mt-3">
              {result.message}
            </p>
          )}
          <div className="exit-btn-container">
            <button
              className="exit-btn"
              onClick={() => navigate("/register")}
            >
              Exit Interview
            </button>
          </div>
        </CardBody>
      </Card>

    </Container>
  );
};

export default Result;